/**
 * Global list of aggregation filter keywords to exclude from the UI.
 * These filters will be hidden from all pages regardless of page-specific config.
 */
export const GLOBAL_EXCLUDED_FILTERS: string[] = [
  'category.keyword',
  // Add more global exclusions here as needed
];
